/** i18n dictionary */
export default {
  landing: {
    header: "时间: 2020 年 10.19-22",
    subheader: "展位号: 4.1 馆 M09",
    products_overview: "Products Overview",
    events_and_news: "Events and News",
    make_appointment: "预约",
    form_header: "有兴趣成为我们的经销商吗",
    phone_tab: "手机号",
    phone_placeholder: "请留下您的手机号",
    email_tab: "电邮",
    email_placeholder: "请留下您的邮箱地址",
    submit_button: "提交",
    confirmation_text: "已收到您的联系方式。稍微会有橙汇的工作人员联系您。"
  },
  make_appointment: {
    title: "预约",
    date_slot_header: "请选择日期",
    date_field_text: "*日期:",
    date_dropdown_options: [
      {text: "  日期  " , value: "", disabled: true},
      {text: "10月19日", value: "2020-10-19"},
      {text: "10月20日", value: "2020-10-20"},
      {text: "10月21日", value: "2020-10-21"},
      {text: "10月22日", value: "2020-10-22"},
    ],
    time_slot_header: "请选择时间",
    time_field_text: "*时间:",
    time_dropdown_options: [
      {text: "  时间  " , value: "", disabled: true},
      {text: "9:30 AM", value: "9:30 AM"},
      {text: "10:00 AM", value: "10:00 AM"},
      {text: "10:30 AM", value: "10:30 AM"},
      {text: "11:00 AM", value: "11:00 AM"},
      {text: "11:30 AM", value: "11:30 AM"},
      {text: "12:00 PM", value: "12:00 PM"},
      {text: "12:30 PM", value: "12:30 PM"},
      {text: "1:00 PM",  value: "1:00 PM" },
      {text: "1:30 PM",  value: "1:30 PM" },
      {text: "2:00 PM",  value: "2:00 PM" },
      {text: "2:30 PM",  value: "2:30 PM" },
      {text: "3:00 PM",  value: "3:00 PM" },
      {text: "3:30 PM",  value: "3:30 PM" },
      {text: "4:00 PM",  value: "4:00 PM" },
      {text: "4:30 PM",  value: "4:30 PM" },
      {text: "5:00 PM",  value: "5:00 PM" },
    ],
    first_name_field_text: "*姓:",
    last_name_field_text: "*名:",
    email_field_text: "邮箱:",
    mobile_phone_field_text: "*手机号:",
    submit_button_text: "预约",
    confirmation_text: "您已经预定成功！稍后会有我们公司的专员联系您.",
  },
  about_us: {
    title: "我们是谁",
    verbiage: `拥有20年以上杰出行业经验的国际化团队，以及海内外的精英战略合作伙伴，橙汇科技注定成为全球领先的医疗电缆与部件的专业制造厂家。丰富的研发设计、生产制造、质量控制及供应链管理资源，应用数据库及IT技术，为客户提供前所未有的卓越产品品质，以及从需求到交付的可视性高效服务。总部位于深圳，橙汇科技投资数千万元建立了业内最先进的研发、检测、生产及仓储等设施，全方位落实执行ISO13485:2016质量管理体系，生产工厂经美国FDA注册登记，医疗产品获得包括美国FDA市场准入、欧盟CE认证及中国CFDA注册。`,
    video_url: "https://orantech-images.s3-ap-southeast-1.amazonaws.com/Orantech_Company_Video_Mobile_Chinese.mov",
  },
  products: {
    download_brochures: "下载手册",
    view_more: "查看更多",
    view_fewer: "折叠",
  },
  events: {
    title: "Events and News"
  },
  team: {
    title: "Meet our MEDICA Team",
    verbiage: "These are our team members that you will meet at MEDICA. We produce accessories for the most popular patient monitors by brands like GE, Phillips, Masimo, Nellcor, Mindra, Nihon Koden, Datex and many more. All our products are manufactured to function equivalent to OEMs. Accurate sensitivity and signal response combined with reliable performance and durability make our price-conscious products popular in major hospitals as well as specialized clinics. We also manufacture OEM parts by contract.",
    contact_header: "Contact",
    email_field_text: "Email:",
    phone_field_text: "Phone:",
  },
}
